module.exports = __webpack_public_path__ + "img/units-outline.d8c08fb2.svg";